import { BaseEntity, Transform, toDate } from './base';

export class UnservicedDay extends BaseEntity {
  @Transform(toDate)
  date: Date;
}
